<template>
  <div class="container-fluid">
    <v-wait for="sets-loading">
      <template slot="waiting">
        <div class="vue-wait-class">
          <img src="static/loading.svg" />
          <p>Setler yükleniyor...</p>
        </div>
      </template>
      <div class="row mt-4">
        <div class="col-md-3 col-xl-4" v-for="(set, index) in sets" v-bind:key="'set-' + index">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">{{set.SET_NAME}}</h5>
              <p class="card-text">{{set.SET_DESCRIPTION}}</p>
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(malzeme, indm) in parseSetIcerik(set.SET_ICERIK)" v-bind:key="'malz-'+indm">
                {{malzeme.MALZEME_NAME}}<span class="badge badge-primary badge-pill badge-font-size float-right">{{malzeme.MALZEME_QUANTITY}}</span>
              </li>
            </ul>
            <div class="card-body">
              <small class="text-muted">{{set.PERSONEL_NAME}}</small>
              <small class="text-muted float-right">{{set.SET_CREATED_FORMATTED}}</small>
            </div>
          </div>
        </div>
      </div>
    </v-wait>
  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'

export default {
  name: 'SetlerPage',
  data () {
    return {
      sets : []
    }
  },
  computed: {
    getPersonelName : function() { return this.$store.state.user.personelName },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    getSets() {
      this.$wait.start('sets-loading')
      axios.post('/api/stok/tum-setler?sessionId=' + this.getSessionId)
      .then(response => {
        this.sets = response.data
      })
      .catch(error => { 
        console.error(error) 
      })
      this.$wait.end('sets-loading')
    },
    parseSetIcerik(icerik) {
      let arr = icerik.split(',');
      let data = []
      for(let i = 0; i < arr.length; i++) {
        let obs = arr[i].split('-');
        let ob1, ob2, ob3, ob4;
        ob1 = obs[0];
        ob2 = obs[1];
        ob3 = obs[2];
        ob4 = obs[4];
        data.push({'MALZEME_CODE': ob1, 'MALZEME_NAME': ob2, 'MALZEME_QUANTITY': ob3, 'MALZEME_ID': ob4});
      }
      return data;
    }
  },
  mounted() {
    this.getSets()
  }
}
</script>

<style scoped>

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img, .vue-wait-class i {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .badge-font-size {
    font-size: .875rem;
    font-weight: 400;
  }

  .card {
    box-shadow: 0px 5px 10px -5px rgba(0,0,0,0.125);
  }

  .card .list-group-item {
    font-size: .875rem;
    padding-top: 6px;
    padding-bottom: 6px;
  }

</style>



// WEBPACK FOOTER //
// src/components/SetlerPage.vue